import { rum } from '@divvy-web/utils.log'

import { getAuthIdFromStorage, getTokenFromStorage } from '@sputnik/auth/localStorageUtils'

const getCurrentAuthId = () => {
  const token = getTokenFromStorage()
  if (!token) {
    return {}
  }

  const authId = getAuthIdFromStorage()
  if (!authId) {
    return {}
  }

  return { session_id: authId }
}

// Logs error to logging service
export const logError = (error, { attributes = {}, eventName = '', message = '' }) => {
  rum.addError(error, {
    attributes,
    eventName,
    logType: 'ERROR',
    message,
    ...getCurrentAuthId(),
    squad: 'Vibranium',
  })
}

// Logs warning to logging service
export const logWarning = (name: string, { attributes = {}, eventName = '', message = '' }) => {
  rum.addAction(name, {
    attributes,
    eventName,
    message,
    logType: 'WARNING',
    ...getCurrentAuthId(),
    squad: 'Vibranium',
  })
}

// Logs info to logging service
export const logInfo = (name: string, { attributes = {}, eventName = '', message = '' }) => {
  rum.addAction(name, {
    attributes,
    eventName,
    message,
    logType: 'INFO',
    ...getCurrentAuthId(),
    squad: 'Vibranium',
  })
}
